<template>
  <component
    :is="parentModule.config.general.template.component"
    :id="module.id"
    class="card"
    :parent-general="parentModule.config.general"
  >
    <template #media>
      <GlobalUIMedia
        :media="module.config.media"
        placement="front"
        :image-widths="imageWidths"
        :ratio="parentModule.config.general.imageProportions?.value"
        :lazy="lazy"
        :ignore-media-styles="true"
      />
    </template>

    <template v-if="parentModule.config.general.showHeader" #header>
      <CardUIHeader :header="module.config.header" />
    </template>

    <template v-if="parentModule.config.general.showText" #text>
      <CardUIText :text="module.config.text" />
    </template>

    <template v-if="parentModule.config.general.showCtaButton" #ctaButton>
      <div class="cta-button-container">
        <GlobalUICtaButton
          :cta-button="module.config.ctaButton"
          @click="$emit('emittedClick')"
        />
      </div>
    </template>
  </component>
</template>

<script>
import cardModule from "./cardDefaultModuleProp";
import cardsModule from "../Cards/cardsDefaultModuleProp";

import GlobalUICtaButton from "../../GlobalUI/GlobalUICtaButton.vue";
import GlobalUIMedia from "../../GlobalUI/GlobalUIMedia.vue";

import CardUIText from "../UI/CardUIText.vue";
import CardUIHeader from "../UI/CardUIHeader.vue";

import CardPortraitSmall from "../Templates/CardPortraitSmall.vue";
import CardPortraitBig from "../Templates/CardPortraitBig.vue";
import CardLandscapeSmall from "../Templates/CardLandscapeSmall.vue";
import CardLandscapeBig from "../Templates/CardLandscapeBig.vue";
import CardDynamic from "../Templates/CardDynamic.vue";

export default {
  name: "Card",
  components: {
    GlobalUICtaButton,
    GlobalUIMedia,
    CardUIText,
    CardUIHeader,

    CardPortraitSmall,
    CardPortraitBig,
    CardLandscapeSmall,
    CardLandscapeBig,
    CardDynamic,
  },
  props: {
    module: {
      type: Object,
      default() {
        return cardModule;
      },
    },
    parentModule: {
      type: Object,
      default() {
        return cardsModule;
      },
    },
    lazy: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageWidths() {
      switch (this.parentModule.config.general.template.component) {
        case "CardPortraitSmall":
          return {
            mobile: 325,
            tablet: 345,
            laptop: 276,
            desktop: 368,
          };
        case "CardPortraitBig":
          return {
            mobile: 325,
            tablet: 706,
            laptop: 780,
            desktop: 780,
          };
        case "CardLandscapeSmall":
          return {
            mobile: 325,
            tablet: 353,
            laptop: 284,
            desktop: 396,
          };
        case "CardLandscapeBig":
          return {
            mobile: 325,
            tablet: 353,
            laptop: 375,
            desktop: 375,
          };
        case "CardDynamic":
          return {
            mobile: 342,
            tablet: 377,
            laptop: 568,
            desktop: 728,
          };
      }
    },
  },
};
</script>

<style scoped lang="scss">
@include reset;
</style>
